﻿/* https://brandplatform.smartphoto.com/general/atoms/language-selector/ */
import { compositeDisposable, IDisposable } from "../../utils/disposable";
import { expressEventListener, expressQuerySelectorAll, isMobile } from "../../common/html";
import { createDropDownKeyboardNavigator } from "../technical/keyboard-navigator";

export function initLanguageSelector(buttonEl: HTMLElement) {
	let eventDisposables: IDisposable;
	let onDocumentClickDisposable: IDisposable;
	const openClassName = "a-language-selector--open";

	const closeMenu = () => {
		buttonEl.classList.remove(openClassName);
		detachDocumentClick();
	};

	const openMenu = () => {
		buttonEl.classList.add(openClassName);
		attachOnDocumentClick();
	};

	const isClosed = () => !buttonEl.classList.contains(openClassName);

	const onDocumentClick = (e: MouseEvent) => {
		if (!(e.target as HTMLElement).closest(".technical-language-selector, .technical-language-selector-choices")) {
			closeMenu();
		}
	};

	const onButtonClick = () => {
		// we do don't want to load or attach handlers when the menu is closing
		if (isClosed()) attachOnDocumentClick();
		buttonEl.classList.toggle(openClassName);
	};

	const attachOnDocumentClick = () =>
		(onDocumentClickDisposable = compositeDisposable([expressEventListener(document, "click", onDocumentClick, true)]));

	const detachDocumentClick = () => onDocumentClickDisposable && onDocumentClickDisposable.dispose();

	const init = () => {
		eventDisposables = compositeDisposable([expressEventListener(buttonEl, "click", onButtonClick)]);
		if (!isMobile())
			eventDisposables.add(
				createDropDownKeyboardNavigator(buttonEl, {
					onEscape: closeMenu,
					onEnter: openMenu,
					onBeforeArrowDown: () => {
						if (isClosed()) openMenu();
					},
					dropdownItemEls: expressQuerySelectorAll(buttonEl, ".a-language-selector__link"),
				}),
			);
	};

	const deInit = () => {
		dispose();
		closeMenu();
	};

	// remove all handlers
	const dispose = () => {
		if (eventDisposables) eventDisposables.dispose();
		detachDocumentClick();
	};

	// init component
	init();

	return {
		deInit,
	};
}
